import { IFiCustomerData } from '@fi-shared/fi-shared-services/fi-customer-data.service';

export const CcmSessionData = {
    Desktop: {
        IsCompactMode: false,
    },
    IsExtendedAccessSession: false,
    LocalSearch: {
        Module: '',
        SearchParams: [],
        Reset: () => {
            CcmSessionData.LocalSearch.Module = '';
            CcmSessionData.LocalSearch.SearchParams = [];
        },
        Reinitialize: (data) => {
            if (data) {
                CcmSessionData.LocalSearch.Module = data.Module;
                CcmSessionData.LocalSearch.SearchParams = data.SearchParams;
            } else CcmSessionData.LocalSearch.Reset();
        },
        ModuleExactMatch: undefined,
    },
    Reset: () => {
        CcmSessionData.LocalSearch.Reset();
    },
    Reinitialize: (data) => {
        CcmSessionData.Desktop = data.Desktop;
        CcmSessionData.LocalSearch.Reinitialize(data.LocalSearch);
    },
};
